export default "__VITE_ASSET__CmUx_oig__"